















import { Component, Vue, Provide } from 'vue-property-decorator';
import newOrder from "./components/newOrder.vue";
import automatiCall from "./components/automatiCall.vue";

@Component({
  name: 'orderDeal',
  components: { newOrder, automatiCall }
})
export default class CombinationProperty extends Vue {
  @Provide() private systemInfo: any = "";
  @Provide() private activeName:string = "new";
  private handleClick(tab:any, event:any) {
    // 点击tab,缓存
    localStorage.setItem('tabC', tab.name);
  }; 
  private created() {
    // 刷新页面获取缓存或者默认值
    this.activeName = localStorage.getItem('tabC') || 'new'; 
  }
  private destroyed() {
    // 页面销毁时,将缓存修改为默认值，以便第一次进入时查看默认选中tab
    localStorage.setItem('tabC', 'new');
  }
}
